import React from "react";
import { injectIntl } from "react-intl";
import { getTimeUnits, ScreenReaderOnly } from "@trainline-shareable/utils";
const FormattedDuration = ({ value, intl: { formatMessage } }) => {
  const { hours, minutes } = getTimeUnits({
    durationInMs: value,
    unitsRequested: ["hours", "minutes", "seconds"],
    asUnit: true,
    roundup: true
  });
  const duration = formatMessage({ id: "hoursAndMinutesDuration" }, { hours, minutes });
  const accessibleHours = formatMessage({ id: "hours.accessibility" }, { hours });
  const accessibleMinutes = formatMessage({ id: "minutes.accessibility" }, { minutes });
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("time", {
    "aria-hidden": true
  }, duration), /* @__PURE__ */ React.createElement(ScreenReaderOnly, null, /* @__PURE__ */ React.createElement("time", null, Boolean(hours) && accessibleHours, " ", Boolean(minutes) && accessibleMinutes)));
};
var FormattedDuration_default = injectIntl(FormattedDuration);
export {
  FormattedDuration_default as default
};
